import axios from "axios";
import { APP_URL } from "../../config/api";
import { errorMessage } from "../errorHandle";

export const getAllHomeTrainings = () => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-home-trainings`,
      })
      .then((res) => {
        dispatch({
          type: HOME.ALL_HOME_TRAININGS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const getAllHomeCertification = () => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/certifications`,
      })
      .then((res) => {
        dispatch({
          type: HOME.ALL_HOME_CERTIFICATION,
          payload: res.data.list,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const getAllHomeCourse = () => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/courses`,
      })
      .then((res) => {
        dispatch({
          type: HOME.ALL_HOME_CERTIFICATION,
          payload: res.data.list,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const searchByCourses = (parm) => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/search-by-courses`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: HOME.SEARCH_HOME_COURSES,
          payload: res.data.list,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const searchByCertifications = (parm) => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/search-by-certifications`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: HOME.SEARCH_HOME_CERTIFICATIONS,
          payload: res.data.list,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const getCertificationDetails = (parm) => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-certification-details`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: HOME.GET_CERTIFICATION_DETAILS,
          payload: res.data,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const trainingRegisterFrom = (student) => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/register-training-student`,
        data: student,
      })
      .then((res) => {
        dispatch({
          type: HOME.TRAINING_REGISTER,
          payload: res.data,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const sendEmailOtp = (cred) => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/email-otp-register`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: HOME.EMAIL_OTP,
          payload: res.data.email_otp,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

export const sendMobileOtp = (cred) => {
  return (dispatch) => {
    dispatch({
      type: HOME.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/mobile-otp-register`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: HOME.MOBILE_OTP,
          payload: res.data.mobile_otp,
        });
      })
      .catch((error) => {
       dispatch(errorMessage(error, HOME.ERROR));
      });
  };
};

const TAG = "HOME_";

export const HOME = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  ALL_HOME_TRAININGS: TAG + "ALL_HOME_TRAININGS",
  ALL_HOME_COURSES: TAG + "ALL_HOME_COURSES",
  ALL_HOME_CERTIFICATION: TAG + "ALL_HOME_CERTIFICATION",
  GET_CERTIFICATION_DETAILS: TAG + "GET_CERTIFICATION_DETAILS",
  SEARCH_HOME_COURSES: TAG + "SEARCH_HOME_COURSES",
  SEARCH_HOME_CERTIFICATIONS: TAG + "SEARCH_HOME_CERTIFICATIONS",
  TRAINING_REGISTER: TAG + "TRAINING_REGISTER",
  EMAIL_OTP: TAG + "EMAIL_OTP",
  MOBILE_OTP: TAG + "MOBILE_OTP",
};
